export const CLICK_AND_COLLECT_MACHINE_STATES = {
	IDLE: 'idle',
	CAC_FLOW_MACHINE: 'cacFlowMachine'
};
